import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MdCustomer, MdCustomerCondition } from 'models/md/MdCustomer';
import { callApi } from 'utils/ApiUtil';

/**
 * 형개발 고객사 정보 목록 조회
 * @param condition
 * @returns
 */
export const findMdCustomerList = async (condition: MdCustomerCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/customer`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdCustomer[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdCustomer[];
};

/**
 * 형개발 고객사 정보 저장
 * @param masterData
 * @returns
 */
export const saveMdCustomer = async (masterData: MdCustomer[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/customer`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};
